import store from "@/store";

export default function isClassifiedForMedication({ next, router }) {
  const isClassifiedForMedication =
    store.getters["user/isClassifiedForMedication"];

  if (isClassifiedForMedication) {
    return next();
  }

  return router.push({ name: "WeightLoss.Dashboard" });
}
